module.exports = __webpack_public_path__ + "img/4_b.61c519fd.jpg";